var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTableColumnsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 28,
    viewBox: "0 0 25 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 21057"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 5363 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 3C4 1.34315 5.34315 0 7 0H17.4444C19.1013 0 20.4444 1.34315 20.4444 3V25C20.4444 26.6569 19.1013 28 17.4444 28H7C5.34314 28 4 26.6569 4 25V3ZM7 2C6.44772 2 6 2.44772 6 3V25C6 25.5523 6.44771 26 7 26H17.4444C17.9967 26 18.4444 25.5523 18.4444 25V3C18.4444 2.44771 17.9967 2 17.4444 2H7Z",
    fill: "#1B224C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 1759 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 6C24.5523 6 25 6.44772 25 7L25 21C25 21.5523 24.5523 22 24 22C23.4477 22 23 21.5523 23 21L23 7C23 6.44772 23.4477 6 24 6Z",
    fill: "#1B224C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 1760 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 6C1.55228 6 2 6.44772 2 7L2 21C2 21.5523 1.55228 22 0.999999 22C0.447715 22 -6.79809e-07 21.5523 -6.55668e-07 21L-4.37112e-08 7C-1.95702e-08 6.44772 0.447715 6 1 6Z",
    fill: "#1B224C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableColumnsIcon);
export default __webpack_public_path__ + "static/media/tableColumnsIcon.fc5890b8f0ea02f29d83c2271cbdc21e.svg";
export { ForwardRef as ReactComponent };